import {isNullOrUndefined} from "../../services/Validator";

export default function SystemAppScreenLayout({children}) {
    // Used in CoursesScreen to frame screen content

    // BUILD
    if (isNullOrUndefined(children))
        return null;
    return (
        <div className={"overflow-auto bg-backgroundLight3 h-[100vh] grow flex flex-col justify-start items-center"}>
            {children}
        </div>
    );
}